import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-default',
  templateUrl: './default-route.component.html',
  styleUrls: [ './default-route.component.scss' ]
})

export class DefaultRouteComponent {

    constructor() {
    }
}
